import { I18n } from '@calendly/i18n';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { useEventType } from 'features/event_type_provider';
import { AdditionalSettings } from './additional_settings';
import { CrudAutomationsSection } from './crud_automations_section';
import { CrudBasicNotificationsSection } from './crud_basic_notifications_section';
import { CrudNotificationDrawer } from './crud_notification_drawer';
import { getCrudNotificationSectionConfig } from './notification_section_config';
import { useSelectedSections } from '../../../components/selected_sections';
const surfaceCss = "s82zlyl";

// Clips the editor slide-in to this column so it enters from the container edge,
// not across the full viewport / tab nav.
const editingSurfaceCss = "em1csco";
const headerCss = "h1kb6dip";
const dividerCss = "dupmsba";
const NotificationsList = () => <>
    <div className={headerCss}>
      <TitleText level={2} size="large" as="h2">
        {I18n.t('publisher.event_type_editor.sections.more_options.notifications.page_title')}
      </TitleText>
      <BodyText color="muted" size="large">
        {I18n.t('publisher.event_type_editor.sections.more_options.notifications.page_subtitle')}
      </BodyText>
    </div>
    <CrudBasicNotificationsSection />
    <CrudAutomationsSection />
    <div className={dividerCss} role="separator" />
    <AdditionalSettings />
  </>;

// Dedicated notifications surface for the new Event Type CRUD editor. Renders the
// redesigned page structure (title + subtitle, Basic notifications cards, the
// Automations entry point, and Additional settings). Editing a basic notification
// replaces this list in place while the Notifications tab stays active.
// Persistence stays owned by the parent CRUD flow — this surface never submits
// on its own.
export const CrudNotificationsSurface = () => {
  const eventType = useEventType();
  const {
    selectedSections
  } = useSelectedSections();
  const selected = selectedSections?.[0];
  const isEditingBasicNotification = Boolean(selected && getCrudNotificationSectionConfig(selected.key, eventType));
  return <div className={isEditingBasicNotification ? editingSurfaceCss : surfaceCss} data-testid="crud-notifications-surface">
      {isEditingBasicNotification ? <CrudNotificationDrawer /> : <NotificationsList />}
    </div>;
};

require("./crud_notifications_surface.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./crud_notifications_surface.js");